// eslint-disable-next-line no-shadow
export const WebhookEventNames = {
  PROPOSAL_CONTENT_UPDATED: 'proposal.content_updated',
  PROPOSAL_CREATED: 'proposal.created',
  PROPOSAL_PUBLISHED: 'proposal.published',
  PROPOSAL_UNPUBLISHED: 'proposal.unpublished',
  PROPOSAL_OPENED: 'proposal.opened',
  PROPOSAL_SIGNED: 'proposal.signed',
  PROPOSAL_STATUS_CHANGED: 'proposal.status_changed',
  PROPOSAL_DECLINED: 'proposal.declined',
  PROPOSAL_DELETED: 'proposal.deleted',
};
